import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-manual-student-table",
	templateUrl: "./manual-student-table.component.html",
	styleUrls: ["./manual-student-table.component.css"],
})
export class ManualStudentTableComponent implements OnInit {
	constructor() {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() AddToList: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	@Input() loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any = [];
	@Input() lstPerson: any = [];

	//Filter lists
	lstGradeLevelDesc: any = [];
	lstHomeroom: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "GradeLevelDesc", header: "Grade Level" },
		{ field: "Homeroom", header: "Homeroom" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	UpdateData() {
		this.lstGradeLevelDesc = [];
		this.lstHomeroom = [];
		this.lstActiveDesc = [];

		if (this.lstPerson == undefined || this.lstPerson.length == 0) {
			return;
		}

		this.lstGradeLevelDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.GradeLevelDesc))).sort();
		this.lstHomeroom = Array.from(new Set(this.lstPerson.map((item: any) => item.Homeroom))).sort();
		this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onAddToList() {
		var lstEmail: any = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			var newData: any = {
				Active: next.Active,
				ActiveDesc: next.ActiveDesc,
				Email: next.Email,
				FirstName: next.FirstName,
				GradeLevelDesc: next.GradeLevelDesc,
				Homeroom: next.Homeroom,
				LastName: next.LastName,
				PersonID: next.PersonID,
				SchoolFullName: next.SchoolFullName,
				StudentID: next.StudentID,
			};

			lstEmail = [...lstEmail, newData];
		}

		// this.AddToList.emit(this.SelectedPersons);
		this.AddToList.emit(lstEmail);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////
}
